import { useEffect, useRef, useState } from 'react';
import { getUncatchEndpointData } from '../utils/request';
import { NodalCapacityMapData } from '../components/nodalCapacityHeatMap/NodalCapacityHeatMapView';

type Options = {
  /** Endpoint a llamar: 'mapElements/nodal-capacity/public' | 'mapElements/nodal-capacity/internal' */
  endpoint: string;
  alimentadorIds: number[];
};

type State = {
  data: NodalCapacityMapData | null;
  loading: boolean;
  error: string | null;
};

/**
 * Carga capacidad nodal SOLO cuando hay alimentadorIds (comunas seleccionada).
 * El endpoint diferencia público (solo Publica) de interno (todos).
 */
export function useNodalCapacityMapData({ endpoint, alimentadorIds }: Options): State {
  const [state, setState] = useState<State>({ data: null, loading: false, error: null });
  const prevIdsRef = useRef<string>('');

  useEffect(() => {
    const idsKey = alimentadorIds.join(',');

    if (alimentadorIds.length === 0) {
      prevIdsRef.current = '';
      setState({ data: null, loading: false, error: null });
      return;
    }

    // Evitar refetch si los ids no cambiaron
    if (idsKey === prevIdsRef.current) return;
    prevIdsRef.current = idsKey;

    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true, error: null }));

    (async () => {
      try {
        const res = await getUncatchEndpointData({
          endpoint,
          query: { alimentadorIds: idsKey }
        });
        if (!cancelled) {
          setState({ data: res as NodalCapacityMapData, loading: false, error: null });
        }
      } catch (e) {
        if (!cancelled) {
          // Resetear prevIdsRef para permitir reintentos si hubo un error de red/auth
          prevIdsRef.current = '';
          setState({ data: null, loading: false, error: String(e) });
          console.error('[useNodalCapacityMapData] Error fetching', endpoint, 'ids:', idsKey, e);
        }
      }
    })();

    return () => { cancelled = true; };
  }, [endpoint, alimentadorIds]);

  return state;
}
